import { Link, Text } from '@lego/klik-ui';
import type { StoreService } from '@/hooks/store';
import { paths } from '@/utility/global_paths';
import { storeServiceColumns } from '../common/table/column_definitions/StoreServices';
import { TableStoreProvider } from '../common/table/store/Context';
import { Table } from '../common/table/Table';

const storeDescription = (
  <Text>
    Services available in the EMMA registry for all workspaces.{' '}
    <Link href="https://github.com/LEGO/EMMA-Store" isExternal>
      Source on GitHub
    </Link>
    . Contributions are welcome!
  </Text>
);

type Props = {
  services: StoreService[] | undefined;
};

export const StoreServicesTable = (props: Props) => {
  return (
    <TableStoreProvider initialSorting={[{ desc: true, id: 'id' }]} name="Services">
      <Table
        columns={storeServiceColumns}
        count={props.services?.length || 0}
        data={props.services || []}
        description={storeDescription}
        isLoading={!props.services}
        rowLink={({ name }) => paths.storeByServiceName(name)}
        title="Store"
      />
    </TableStoreProvider>
  );
};
